module.exports = __webpack_public_path__ + "images/help/video-files-small-e6857ffcaaac3692a9be0c5baf41bf3c.png";